package pl.michal_cyran.brand_hub.subpages.dayMathAd.sections

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.icons.fa.FaCircleCheck
import com.varabyte.kobweb.silk.components.icons.fa.FaDumbbell
import com.varabyte.kobweb.silk.components.icons.fa.FaForwardStep
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Br
import org.jetbrains.compose.web.dom.H1
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text
import pl.michal_cyran.brand_hub.HeroGridStyle
import pl.michal_cyran.brand_hub.components.widgets.DeviceMockup
import pl.michal_cyran.brand_hub.components.widgets.VisibilityAware
import pl.michal_cyran.brand_hub.components.widgets.revealFadeSlideUp
import pl.michal_cyran.brand_hub.components.widgets.revealFadeSlideUpScale
import pl.michal_cyran.brand_hub.components.widgets.staggerDelay
import pl.michal_cyran.brand_hub.toSitePalette

@Composable
fun DayMathGenerators() {
    val cm = ColorMode.current.toSitePalette()

    SimpleGrid(
        numColumns(base = 1, md = 2),
        HeroGridStyle.toModifier()
    ) {

        VisibilityAware(
            modifier = Modifier
        ) { isVisible ->
            Column(
                modifier = Modifier
                    .width(100.percent)
                    .revealFadeSlideUpScale(
                        isVisible,
                        delayMs = 200,
                        distance = 32.px,
                        fromScale = 0.92
                    ),
                horizontalAlignment = Alignment.CenterHorizontally,
                verticalArrangement = Arrangement.Center,
            ) {
                DeviceMockup("daymath_ss/generators")
            }
        }

        VisibilityAware(
            modifier = Modifier
        ) { isVisible ->
            Column {

                H1(
                    Modifier
                        .revealFadeSlideUp(isVisible, delayMs = 120)
                        .toAttrs()
                ) {
                    SpanText(
                        "Automatyczny trening ",
                        modifier = Modifier
                            .color(cm.textMuted)
                    )
                    Br()
                    SpanText(
                        "mistrza algebry.",
                        modifier = Modifier
                            .color(cm.primary)
                    )
                }

                P(
                    Modifier
                        .revealFadeSlideUp(isVisible, delayMs = 240)
                        .toAttrs()
                ) {
                    Text(
                        "Nasze algorytmy generują unikalne równania liniowe, kwadratowe i nierówności. Ty ustalasz poziom trudności, my dostarczamy nieskończoną ilość materiału do ćwiczeń. "
                    )
                }

                FeatureRow(
                    icon = { FaForwardStep() },
                    text = "Rozwiązania krok po kroku",
                    modifier = Modifier
                        .revealFadeSlideUp(
                            isVisible,
                            delayMs = staggerDelay(0, step = 90, offset = 260)
                        )
                )
                FeatureRow(
                    icon = { FaCircleCheck() },
                    text = "Sprawdzanie odpowiedzi",
                    modifier = Modifier
                        .revealFadeSlideUp(
                            isVisible,
                            delayMs = staggerDelay(1, step = 90, offset = 260)
                        )
                )
                FeatureRow(
                    icon = { FaDumbbell() },
                    text = " Regulowany poziom trudności ",
                    modifier = Modifier
                        .revealFadeSlideUp(
                            isVisible,
                            delayMs = staggerDelay(2, step = 90, offset = 260)
                        )
                )
            }
        }
    }
}

@Composable
fun FeatureRow(
    icon: @Composable () -> Unit,
    text: String,
    modifier: Modifier = Modifier,
) {
    Row(
        modifier = modifier,
        horizontalArrangement = Arrangement.spacedBy(1.cssRem),
        verticalAlignment = Alignment.CenterVertically,
    ) {
        icon()
        Text(text)
    }
}